export default "__VITE_ASSET__ORlCNZQ7__"